<template>
<div class="tip-wrapper">
    <transition-group tag="ul" name="remind">
        <li v-for="a in list" :key="a.keyIndex">

            <p class="suc" v-if="a.type === 'suc'">  <!--成功的样式-->
                {{a.txt}}
            </p>


            <p class="fail" v-if="a.type === 'fail'">  <!--失败的样式-->
                {{a.txt}}
            </p>


            <p class="warning" v-if="a.type === 'warning'">  <!--警告的样式-->
                {{a.txt}}
            </p>


            <p class="info" v-if="a.type === 'info'">  <!--信息的样式-->
                {{a.txt}}
            </p>

            <div class="customer" v-if="a.type === 'customer'" :style="setStyle(a)">  <!--自定义的样式-->
                <span>{{a.txt}}</span>
                <div class="iconFresh" v-if="a.fresh"></div> <!--刷新图标-->
            </div>

        </li>
    </transition-group>
</div>
</template>
<script>
        //    this.$refs.remind.add({  /**示例 */
        //        type:"fail", suc,fail,warning,info,customer
        //        txt:"你是练习时长两年半的个人练习生？",
        //        bg:"#fff",
        //        color:"pink",
        //        continued:true,  /**是否持续 */
        //        continueId:0,  /**调用clear方法移除持续的元素时 传入与创建时相等的ID STRING或者Number */
        //        time:3000, /**如果不持续 就3000毫米后移除 持续为true这个属性无效*/
        //        fresh:true    type为customer有效 显示刷新图标
        //    })

export default {
    name: "tip",
    data () {
        return {
            list:[],   
            keyIndex:0,  /**循环的key */
            continue:[]  /**记录持续显示的元素key索引 */
        }
    },
    methods:{
        add(option){  /**生成提示框 */
            this.keyIndex++  /**生成的索引 */
            
            let type = option.type == "suc" ? "suc" :   option.type == "fail" ? "fail" :     /**选择类型 */
                    option.type == "warning" ? "warning" : option.type == "info" ? "info" : "customer"


            if(type != "customer"){ /**如果不是自定义 就只能设置类型和附加文字*/
                this.list.unshift({   /**配置属性 */
                    keyIndex:this.keyIndex,  /**给循环用的绑定key用的 */
                    type,   /**类型 */
                    txt:option.txt,   /**附加文字 */
                    continueId:option.continueId
                })

            }else{
                this.list.unshift({   /**配置属性 */
                    keyIndex:this.keyIndex,  /**给循环用的绑定key用的 */
                    type:"customer",   /**类型 */
                    txt:option.txt,   /**附加文字 */
                    bg:option.bg,
                    color:option.color,
                    continueId:option.continueId,
                    fresh:option.fresh === true  /**是否有刷新图标 */
                })
            }

                /**设置什么时候自删除 */
            if(!option.continued){  /**有持续属性 不会自己移除 */
                let time = typeof option.time === 'number' ? option.time : 1500   /**设置时间 */
                let delIndex = this.keyIndex  /**记录要删除的索引 */

                setTimeout(()=>{  /**进行移除操作 */
                    for(let i=0,j=this.list.length;i<j;i++){
                        if(this.list[i].keyIndex == delIndex){  /**遍历数组找到要删的元素 */
                            this.list.splice(i,1)   /**删除 */
                            break
                        }
                    }
                },time)
            }
        },

        del(id){  /**移除持续的元素 */
            if(typeof id == "string" || typeof id == "number"){  /**检测传进来的ID是否合法 */
                for(let i=0,j=this.list.length;i<j;i++){
                    if(this.list[i].continueId == id){  /**遍历数组找到要删的元素 */
                        this.list.splice(i,1)   /**删除 */
                        break
                    }
                }

            }else{
                console.error("continueId is not available")
            }
        },

        clear(){  /**清除所有提示 */
            this.list.length = 0
            this.continue.length = 0
        },

        setStyle(option){  /**设置自定义的样式 */
            let res = ''

            if(option.bg){ /**自定义颜色 */
                res = "background:" + option.bg + ";"
            }

            if(option.color){ /**自定义字体颜色 */
                res += "color:" + option.color + ";"
            }
            
            return res
        }
  },
  beforeDestroy(){
      this.list = []
  }
}
</script>
<style scoped>
.remind-leave-active{ 
     position: absolute;
}

.remind-enter{
    transform: translateY(-10rem);
}

.remind-enter-to{
    transform: translateY(0);
}

.remind-leave{
    opacity: 1;
    transform: translateX(0);
}

.remind-leave-to{
    opacity: 0;
    transform: translateX(-50%);
}

</style>
<style lang="stylus" rel='stylesheet/stylus' scoped>

sucColor = #07c160  /**成功的相关颜色 */
failColor = #ee0a24  /**失败的颜色 */
warningColor = #f9ab35
infoColor = #1989fa  

.tip-wrapper
    position fixed
    width 100%
    height auto
    top 0
    left 0 
    z-index 10000
    font-size 1.4rem
    letter-spacing .2rem
    ul
        li /**每个提示的父级 */
            width 100%
            min-height 3rem
            margin-top 1rem
            display flex
            align-items center
            justify-content center
            text-align center
            transition all .3s
            &>p,&>div  /**每个提示 */
                max-width 80%
                color #333
                min-height 3rem
                display flex
                align-items center
                background #fff
                padding 0 1.4rem
                border-radius .3rem
                box-shadow 0 0 .3rem #333
                &>span
                    margin-right .2rem
            .suc  /**成功的提示 */
                color #fff
                background sucColor
                box-shadow 0 0 .3rem sucColor
            .fail  /**失败提示 */
                color #fff
                background failColor
                box-shadow 0 0 .3rem failColor
            .warning  /**警告提示 */
                color #fff
                background warningColor
                box-shadow 0 0 .3rem warningColor
            .info  /**信息提示 */
                color #fff
                background infoColor
                box-shadow 0 0 .3rem infoColor
            .iconFresh  /**刷新图标 */
                flex 0 0 1.6rem
                width 1.6rem
                height @width 
                border-radius 50%
                box-shadow inset 0 0 0 .26rem #3f6cdd
                backface-visibility hidden
                position relative
                &::before,&::after
                    content ''
                    width .9rem
                    height 1.8rem
                    position absolute
                    top -.1rem
                    background #fff
                    backface-visibility hidden
                &::before
                    left -.1rem
                    border-radius 1.6rem 0 0 1.6rem
                    transform-origin .9rem .9rem
                    animation fresh 2s infinite ease 1.5s
                &::after
                    right -.1rem
                    border-radius 0 1.6rem 1.6rem 0
                    transform-origin 0 .9rem
                    animation fresh 2s infinite ease
                @keyframes fresh
                    0
                        transform rotate(0)
                    100%
                        transform rotate(360deg)
                    
</style>


// WEBPACK FOOTER //
// static/plugin/tip/tip.vue